// Script to add specific IDs to product form elements
document.addEventListener('DOMContentLoaded', function() {
  // Add ID to the variant wrapper (first div under product form)
  const variantWrapper = document.querySelector('#product-form-8228836507780 > div > div:first-child');
  if (variantWrapper) {
    variantWrapper.id = 'product-variant-wrapper';
  }
  
  // Add IDs to other elements if needed in the future
  
  console.log('Product form IDs added successfully');
});
